import { PATH_WIDTH } from 'constants/map';
import styled, { css } from 'styled-components';
import { Text } from '@medly-components/core';
import { SearchStatus } from 'context/MapSearchContext/types';

const expandedStyles = css`
    width: max-content;
`;

const collapsedStyles = css`
    span {
        font-size: 4.6rem;
        line-height: 1.5rem;
        transform: translate(0, -90%);
    }
`;

const commonStyles = css<{ scale: number }>`
    display: flex;
    background: ${({ theme }) => theme.colors.royalBlue[50]};
    border: 0.1rem solid ${({ theme }) => theme.colors.royalBlue[500]};
    border-radius: ${({ scale }) => `min(${15 / scale}px, 25px)`};
    position: absolute;
    z-index: 1;
    box-shadow: 0 0 0.8rem ${({ theme }) => theme.colors.grey[500]};
`;

const expandedHorizontalStyles = css`
    max-width: 25rem;
`;

const horizontalStyles = css<{ isExpanded: boolean; scale: number }>`
    ${commonStyles}
    border-bottom: 0;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    padding: ${({ scale }) => `min(${4 / scale}px, 8px) min(${15 / scale}px, 20px) min(${2 / scale}px, 4px) min(${15 / scale}px, 20px)`};
    transform: translate(-50%, calc(-100% + ${PATH_WIDTH + 1}px));
    ${({ isExpanded }) => isExpanded && expandedHorizontalStyles}
`;

const verticalStyles = css<{ scale: number }>`
    ${commonStyles}
    border-right: 0;
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
    transform: translate(calc(-100% + ${PATH_WIDTH}px - 1.4rem), 0);
    padding: ${({ scale }) => `min(${4 / scale}px, 10px) min(${15 / scale}px, 15px)`};
`;

const searchActiveDescriptionTextStyles = css`
    color: white;
`;

export const DescriptionWrapper = styled.div<{ isExpanded: boolean; type: string; scale: number; className: string }>`
    ${({ isExpanded }) => (isExpanded ? expandedStyles : collapsedStyles)}
    ${({ type }) => (type === 'horizontal' ? horizontalStyles : verticalStyles)}
    ${({ className }) => className === SearchStatus.SEARCH_ACTIVE && searchActiveDescriptionTextStyles};

    ${Text.Style} {
        font-size: ${({ scale }) => `min(${14 / scale}px, 20px)`};
        line-height: initial;
    }
`;
